export const _setCalendarEvent = (state, action) => action.payload;
